var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-wrap"},[_c('header-component'),_c('router-view')],1),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }